<div class="typography typography-paragraph typography-body grey-300">
  Количество результатов: {{ count }}
</div>
